import React from 'react';

import styles from './Button.module.scss';

const Button = (props) => {
  let pressTime = new Date().getTime();
  const {
    className,
    style,
    textStyle,
    title,
    icon,
    disabled = false,
    onPress,
    children,
    spm,
    ...others
  } = props;

  const selfPress = (e) => {
    if (disabled) {
      return;
    }
    // 200ms内防止重复点击
    const nowTime = new Date().getTime();
    if (nowTime - pressTime < 300) {
      return;
    }
    // 更新当前时间
    pressTime = new Date().getTime();

    if (typeof onPress === 'function') {
      onPress(e);
    }
  };

  const disableClass = disabled ? styles.disable : '';

  return (
    <div
      onClick={selfPress}
      className={`flex flex-center ${disableClass} ${className}`}
      spm={spm}
      style={{ ...style }}
      {...others}
    >
      {!!title && <span style={{ ...textStyle }}>{title}</span>}
      {!!children && children}
    </div>
  );
};

export default Button;
